var render = function render(_c,_vm){return _c('n8n-tooltip',{attrs:{"content":" ","placement":"top"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._t("default")],2),_c('font-awesome-icon',{class:_vm.$style['icon'],attrs:{"icon":"exclamation-triangle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }